module.exports = __webpack_public_path__ + "img/creative-commons-by.30a79c37.svg";